import {
  AvgLabelCostByCarrierResponseSchema,
  OMSMetricsRequestSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAvgLabelCostByCarrier = {
  name: "getAvgLabelCostByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: AvgLabelCostByCarrierResponseSchema,
};
